import { useEffect, useState } from "react";

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const h = document.documentElement;
      const scrollTop = h.scrollTop || document.body.scrollTop;
      const scrollHeight = h.scrollHeight - h.clientHeight;
      const p = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      setProgress(p);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div
      className="fixed top-0 inset-x-0 h-[3px] z-[60] bg-transparent pointer-events-none"
      data-testid="scroll-progress"
    >
      <div
        className="h-full bg-gradient-to-r from-emerald-brand via-gold to-emerald-brand transition-[width] duration-150"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
